import { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { Badge, type BadgeProps } from '@/components/ui/badge'
import { useRoles } from '@/hooks/useRoles'
import { SessionRolesDialog } from './SessionRolesDialog'
import type { OperatorRole } from '@/types/api'

// Highest-privilege role wins when a wallet holds multiple (eg. admin+mlro).
// Explicit precedence keeps the badge deterministic regardless of array order.
const ROLE_PRIORITY: OperatorRole[] = ['admin', 'mlro', 'read_only']

const ROLE_META: Record<OperatorRole, { label: string; variant: BadgeProps['variant'] }> = {
    admin: { label: 'Admin', variant: 'positive' },
    mlro: { label: 'MLRO', variant: 'inProgress' },
    read_only: { label: 'Read-only', variant: 'muted' },
}

const NONE_META: { label: string; variant: BadgeProps['variant'] } = {
    label: 'No role',
    variant: 'outline',
}

export function RoleBadge() {
    const { roles } = useRoles()
    const top = ROLE_PRIORITY.find((r) => roles.includes(r))
    const meta = top ? ROLE_META[top] : NONE_META
    const [open, setOpen] = useState(false)
    return (
        <>
            <button
                type="button"
                onClick={() => setOpen(true)}
                className="focus-visible:ring-ring rounded-md outline-none focus-visible:ring-2"
                aria-label="View session roles"
            >
                <Badge variant={meta.variant} className="cursor-pointer gap-1">
                    {meta.label}
                    <ChevronDown className="h-3 w-3 opacity-70" />
                </Badge>
            </button>
            <SessionRolesDialog open={open} onOpenChange={setOpen} />
        </>
    )
}
